import { render, staticRenderFns } from "./Workers.html?vue&type=template&id=acf94650&external"
import script from "./Workers.ts?vue&type=script&lang=ts&external"
export * from "./Workers.ts?vue&type=script&lang=ts&external"
import style0 from "./Workers.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports